export default __webpack_public_path__ + "static/media/Pickpocket's Gloves of Engulfing Twilight.c157074a.jpg";